import stampit from 'stampit';
import PathItemServersElement from "../../../../elements/nces/PathItemServers.js";
import BaseServersVisitor from "../ServersVisitor.js";
const ServersVisitor = stampit(BaseServersVisitor, {
  init() {
    this.element = new PathItemServersElement();
  }
});
export default ServersVisitor;